import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button, Input } from 'reactstrap';
import ReactTable from 'react-table';
import FetchNotificationSettingsService from '../../../../../../../Service/OPSServices/ProactiveMonitoringServices/FetchNotificationSettingsService';
import UpdateNotificationSettingsService from '../../../../../../../Service/OPSServices/ProactiveMonitoringServices/UpdateNotificationSettingsService';

function NotificationSettings(props) {
    const [allNotificationSettings, setAllNotificationSettings] = useState([]);
    const [proactiveActionTypeList, setProactiveActionTypeList] = useState();
    const [selectedActions, setSelectedActions] = useState({});
    const [saving, setSaving] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [activeTab, setActiveTab] = useState('new_types');

    useEffect(() => {
        FetchNotificationSettingsService(props.token).then((res) => {
            if (res)  {
                console.log(res);
                setAllNotificationSettings(res.notificationSettingsData)
                setProactiveActionTypeList(res.proactiveActionTypeList)
            }
        });
        }, []);

        const handleTableFieldChange = (rowIndexInFiltered, field, value) => {
            const itemToUpdate = tableData[rowIndexInFiltered];
            
            setAllNotificationSettings(prev => {
                return prev.map(item => {
                    if (item.id !== itemToUpdate.id) return item;
    
                    if (field === "problemAreaId") {
                        return { ...item, problemAreaId: value, problemAreaPathwayId: "", requestSubTypeId: "" };
                    }
                    if (field === "problemAreaPathwayId") {
                        return { ...item, problemAreaPathwayId: value, requestSubTypeId: "" };
                    }
                    return { ...item, [field]: value };
                });
            });
    
            if (props.handleTableFieldChange) {
                
                const masterIndex = allNotificationSettings.findIndex(attr => attr.id === itemToUpdate.id);
                props.handleTableFieldChange(masterIndex, field, value);
            }
        };

        const isRowTicket = (row) => {
            const currentActionId = selectedActions[row.id] !== undefined 
                ? selectedActions[row.id] 
                : row.action_id;
            const actionObj = proactiveActionTypeList && 
                              proactiveActionTypeList.find(a => a.id === Number(currentActionId));   
            return actionObj && actionObj.action && actionObj.action.toLowerCase() === 'ticket';
        };

        const handleActionChange = (value, data) => {
            console.log(data);
            console.log(value);
            setSelectedActions(prev => ({
                ...prev,
                [data.id]: value
            }));
        }

        const handleSave = () => {
            setSaving(true);
            
            // Get all changed actions
            const updates = Object.entries(selectedActions).map(([id, actionId]) => ({
                updatedValue: actionId,
                updatedRow: id
            }));
            const rows = updates.map(u => Number(u.updatedRow));
            const values = updates.map(u => Number(u.updatedValue));
            let data={
                updatedValue:rows ,
                updatedRow:values 
            }
            UpdateNotificationSettingsService(props.token, data).then((res)=>{
                if(res){
                    setSaving(false);
                     window.location.reload();
                }
            })

        };
   console.log(searchText) 
   console.log(allNotificationSettings)
    const lowerSearch = searchText.toLowerCase();
    const getCurrentActionId = (item) => item.action_id;

        const filteredData =
    allNotificationSettings &&
    allNotificationSettings.filter(item => {
        const typeStr = item.notificationType || ""; 
        const typeMatch = typeStr.toLowerCase().includes(lowerSearch);
        
        const actionLabel = item.action_label || "";
        const actionMatch = actionLabel.toLowerCase().includes(lowerSearch);
        
        return typeMatch || actionMatch;
    });

    const matchesActiveTab = (item) => {
        const actionId = getCurrentActionId(item);
        if (activeTab === 'new_types') {
            return !actionId;
        }
        if (!actionId || !proactiveActionTypeList) return false;
        const action = proactiveActionTypeList.find(
            a => a.id === Number(actionId)
        );
    
        if (!action) return false;
    
        const TAB_ACTION_MAP = {
            tickets: 'ticket',
            tasks: 'task',
            notifications: 'notifications'
        };
    
        return action.action.toLowerCase() === TAB_ACTION_MAP[activeTab];
    };
    const tableData = filteredData.filter(matchesActiveTab);
    
    const columns = [
        {
            Header: 'Notification Type',
            accessor: 'notificationType',
            width: 250,
            Cell: cellInfo => (
                <div className="text-start">
                    <p className="m-0 comment-paragraph-Project-product-title">{cellInfo.value}</p>
                </div>
            )
        },
        {
            Header: 'Action',
            accessor: 'action_label',
            width: 180,
            Cell: cellInfo => {
                const rowId = cellInfo.original.id;
                const currentValue = selectedActions[rowId] !== undefined 
                    ? selectedActions[rowId] 
                    : cellInfo.original.action_id;
                    
                return (
                    <div className="d-flex justify-content-center align-items-center w-100">
                        <select
                            className="form-control"
                            value={currentValue || ""}
                            onChange={(e) => handleActionChange(e.target.value, cellInfo.original)}
                        >
                            <option disabled value="">Select Action</option>
                            {proactiveActionTypeList && proactiveActionTypeList.map(action => (
                                <option key={action.id} value={action.id}>
                                    {action.action}
                                </option>
                            ))}
                        </select>
                    </div>
                );
            }
        },
        {
            Header: 'Priority',
            accessor: 'priority',
            width: 180,
            Cell: cellInfo => (
                <div className="text-center">
                    <p className="m-0 comment-paragraph-Project-product-title">{cellInfo.value}</p>
                </div>
            )
        },
        {
            Header: "Problem Area",
            accessor: "problemAreaId",
            Cell: ({ value, index, original }) => (
                <Input
                    type="select"
                    value={value || ""}
                    onChange={(e) => handleTableFieldChange(index, "problemAreaId", e.target.value)}
                    bsSize="sm"
                    disabled={!isRowTicket(original)}
                >
                    <option value="">Select Problem Area</option>
                    {(props.problemAreaList || []).map((pa) => (
                        <option key={pa.id} value={pa.id}>{pa.problemArea}</option>
                    ))}
                </Input>
            ),
        },
        {
            Header: "Problem Pathway",
            accessor: "problemAreaPathwayId",
            Cell: ({ original, value, index }) => {
                const pathwayOptions = original.problemAreaId 
                    ? (props.problemAreaPathwayList || []).filter(pw => String(pw.problemAreaId) === String(original.problemAreaId)) 
                    : [];
                return (
                    <Input
                        type="select"
                        value={value || ""}
                        onChange={(e) => handleTableFieldChange(index, "problemAreaPathwayId", e.target.value)}
                        bsSize="sm"
                        disabled={!isRowTicket(original) || !original.problemAreaId}
                    >
                        <option value="">Select Problem Pathway</option>
                        {pathwayOptions.map((pw) => (
                            <option key={pw.id} value={pw.id}>{pw.problemAreaPathway}</option>
                        ))}
                    </Input>
                );
            },
        },
        {
            Header: "Problem Type",
            accessor: "requestSubTypeId",
            Cell: ({ original, value, index }) => {
                const subTypeOptions = original.problemAreaPathwayId 
                    ? (props.subRequestTypesList || []).filter(st => String(st.problemAreaPathwayId) === String(original.problemAreaPathwayId)) 
                    : [];
                return (
                    <Input
                        type="select"
                        value={value || ""}
                        onChange={(e) => handleTableFieldChange(index, "requestSubTypeId", e.target.value)}
                        bsSize="sm"
                        disabled={!isRowTicket(original) || !original.problemAreaPathwayId}
                    >
                        <option value="">Select Problem Type</option>
                        {subTypeOptions.map((st) => (
                            <option key={st.id} value={st.id}>{st.requestSubTypes}</option>
                        ))}
                    </Input>
                );
            },
        },
        {
        Header: 'Action Required',
        accessor: 'actionrequired',
        width: 180,
        Cell: cellInfo => (
            <div className="text-center">
                <p className="m-0 comment-paragraph-Project-product-title">{cellInfo.value}</p>
            </div>
        )
        },
      
    ];

    return (
        <>
            <Row className="align-items-center mb-2">
                <Col md={4}>
                    <h5 className="mb-0">Action Types</h5>
                </Col>
                <Col md={8}>
                    <div className="d-flex justify-content-end align-items-center gap-2">
                        <Button
                            className="btn-background-color-Proceed-gallery btn-secondary"
                            onClick={handleSave}
                            disabled={saving || Object.keys(selectedActions).length === 0}
                        >
                            {saving ? 'Saving...' : 'Save'}
                        </Button>
                    </div>
                </Col>
            </Row>
            <Row className="mt-3 mb-3 align-items-center">
            <Col md={8}>
                    <div className="brand-tabs d-flex">
                        <div
                            className={`main-tabs ${activeTab === "new_types" ? "active" : ""}`}
                            onClick={() => setActiveTab("new_types")}
                        >
                            New Types
                        </div>

                        <div
                            className={`main-tabs ${activeTab === "tickets" ? "active" : ""}`}
                            onClick={() => setActiveTab("tickets")}
                        >
                            Tickets
                        </div>

                        <div
                            className={`main-tabs ${activeTab === "tasks" ? "active" : ""}`}
                            onClick={() => setActiveTab("tasks")}
                        >
                            Tasks
                        </div>

                        <div
                            className={`main-tabs ${activeTab === "notifications" ? "active" : ""}`}
                            onClick={() => setActiveTab("notifications")}
                        >
                            Notifications
                        </div>
                        </div>
                    </Col>
                    <Col md={4} className="d-flex justify-content-end align-items-center gap-2">
                    <Input
                            type="text"
                            placeholder="Search by Notification Type or Action..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            className="w-100"
                        />
                        {searchText && (
                            <span
                                className="notifications-settings-clear-button"
                                onClick={() => setSearchText("")}
                            >
                                &times;
                            </span>
                        )}
                    </Col> 
            </Row>
            <ReactTable
                data={tableData}
                columns={columns}
                className="-fixed -highlight -striped mt-2"
                getTheadProps={() => ({
                    style: {
                        overflowY: 'hidden',
                        background: '#B1FA63',
                        color: '#243837',
                    },
                })}
               
                defaultPageSize={10}
                noDataText="No Data Found."
            />
        </>
    );
}

const mapStateToProps = state => ({
    token: state.loggedUser.token,
});

export default connect(mapStateToProps)(NotificationSettings);
